import { ColumnDef } from '@tanstack/react-table';
import { FaTrashAlt } from 'react-icons/fa';
import { Notification } from '../../../types/notification';
import { NotificationStatus, NotificationType } from '../../../types/enums';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

type OpenDeleteDialogFn = (notification: Notification) => void;

// دوال مساعدة لعرض الحالات بألوان
const renderNotificationStatus = (status: NotificationStatus) => {
  const styles: { [key in NotificationStatus]: { color: string, text: string } } = {
    [NotificationStatus.UNREAD]: { color: 'blue', text: 'غير مقروء' },
    [NotificationStatus.READ]: { color: 'gray', text: 'مقروء' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

const renderNotificationType = (type: NotificationType) => {
    return type === NotificationType.SMS ? 'رسالة نصية (SMS)' : 'داخل التطبيق';
};

export const getNotificationColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<Notification>[] => [
  {
    header: 'المستخدم',
    accessorFn: (row) => row.user?.email || `ID: ${row.user_id}`,
  },
  {
    header: 'العنوان',
    accessorKey: 'title',
  },
  {
    header: 'النوع',
    accessorKey: 'type',
    cell: ({ row }) => renderNotificationType(row.original.type),
  },
  {
    header: 'الحالة',
    accessorKey: 'status',
    cell: ({ row }) => renderNotificationStatus(row.original.status),
  },
  {
    header: 'تاريخ الإرسال',
    accessorFn: (row) => new Date(row.created_at).toLocaleString('ar-EG'),
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const notification = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <button onClick={() => openDeleteDialog(notification)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
            <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
